@if (show()) {
  <button
    appButton
    name="customize"
    [location]="location()"
    color="simple-primary-no-bg"
    [hasIcon]="true"
    size="1"
    height="-3"
    spacing="-2"
    (click)="onClick.emit()"
    [@button]
  >
    <span>Customize</span>
    <app-svg src="/assets/icons/12/chevron-right.svg" size="-2"></app-svg>
  </button>
}
